var exports = {
  "qV": "Skeleton.module__skeleton___XzlKMG",
  "j1": "Skeleton.module__skeleton-shimmer___XzlKMG",
  "Wq": "Skeleton.module__emphasisStrong___XzlKMG",
  "GN": "Skeleton.module__emphasisMuted___XzlKMG",
  "J": "Skeleton.module__radiusSharp___XzlKMG",
  "n0": "Skeleton.module__radiusSm___XzlKMG",
  "uF": "Skeleton.module__radiusMd___XzlKMG",
  "Ec": "Skeleton.module__radiusLg___XzlKMG",
  "xD": "Skeleton.module__radiusXl___XzlKMG",
  "cP": "Skeleton.module__radiusPill___XzlKMG",
  "by": "Skeleton.module__radiusCircle___XzlKMG",
};

module.exports = exports;
